import { OfferEditor } from '../../../libs/offerSystem/editor/OfferEditor';
import { debugOfferSystemConfig } from './debugOfferSystemConfig';
import { DebugOfferStateHandler } from './DebugOfferStateHandler';

export function openOfferEditor(): void {
  void new OfferEditor(debugOfferSystemConfig, new DebugOfferStateHandler());
}
